import i18n from '@/i18n';
import { router } from '@/router';
import VueViewer from 'v-viewer';
import { App } from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import vuetify from './vuetify';
import { addCollection, Icon } from '@iconify/vue';
import { icons as phIcons } from '@iconify-json/ph';

addCollection(phIcons);

export const registerPlugins = (app: App): App => {
  /******************************************************************************
   * VUE APEX CHARTS, https://apexcharts.com/docs/vue-charts/
   *****************************************************************************/
  app.use(VueApexCharts);

  /******************************************************************************
   * VUE ROUTER
   *****************************************************************************/
  app.use(router);

  /******************************************************************************
   * V-viewer
   *****************************************************************************/
  app.use(VueViewer);

  /******************************************************************************
   * VUE APPLICATION
   *****************************************************************************/

  app.component('Icon', Icon);
  app.use(vuetify).use(i18n);
  return app;
};
